import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './SwitchButton.module.scss';
import { useRouteMatch, useLocation, Link } from 'react-router-dom';
import { getSearchParams } from '../../../../helpers/searchParamsFns';

export const SwitchButton = () => {
  const match = useRouteMatch();
  const location = useLocation();
  const searchParams = getSearchParams(location.search);
  const [activeTab, setActiveTab] = useState(match.url);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [activeTab, location.pathname, match]);

  return (
    <div className={styles.switchContainer}>
      <div
        className={styles.slider}
        style={{
          transform:
            activeTab === '/NewStatistics'
              ? 'translateX(0)'
              : 'translateX(100%)',
        }}
      />
      <Link
        to={{
          pathname: `/NewStatistics`,
          search: `${searchParams}`,
        }}
        className={cn(styles.tab, {
          [styles.active]: activeTab === '/NewStatistics',
        })}
      >
        Диаграммы
      </Link>
      <Link
        to={{
          pathname: `/NewStatistics/report`,
          search: `${searchParams}`,
        }}
        className={cn(styles.tab, {
          [styles.active]: activeTab === '/NewStatistics/report',
        })}
      >
        Сводный отчет
      </Link>
    </div>
  );
};
